import {Recorder} from "../Recorder";
import {RecorderData, RecordType} from "../../Shared/Shared";
import {RecorderBase} from "./RecorderBase";
import "jQuery";
import {MouseRecorder} from "./MouseRecorder";
export class ResizeRecorder extends RecorderBase{
    public resizeFired:boolean=true;
    public lastRecordedWidth:number;
    public lastRecordedHeight:number;
    public timeOut:any;
    constructor(recorder: Recorder) {
        super(recorder);
        jQuery(window).resize(()=>{this.resizeFired=true; this.SizeChanged();})
    }



    private SizeChanged() {

        if(this.resizeFired)
        {
            if(this.timeOut!=null)
                clearTimeout(this.timeOut);
            this.resizeFired=false;
            this.timeOut=setTimeout(()=>this.SizeChanged(),300);
        }else{
            let auxWidth=jQuery(window).width();
            let auxHeight=jQuery(window).height();
            if(this.lastRecordedWidth!=auxWidth||this.lastRecordedHeight!=auxHeight) {
                this.lastRecordedHeight=auxHeight;
                this.lastRecordedWidth=auxWidth;
                this.recorder.SendData({
                    type: RecordType.Resize,
                    value: {width: auxWidth, height:auxHeight}
                });
            }
        }
    }
}




// WEBPACK FOOTER //
// ./Recorder/RecordElements/ResizeRecorder.ts